import { render, staticRenderFns } from "./CommingDrawsWrapper.vue?vue&type=template&id=7288af8f&scoped=true"
import script from "./CommingDrawsWrapper.vue?vue&type=script&lang=js"
export * from "./CommingDrawsWrapper.vue?vue&type=script&lang=js"
import style0 from "./CommingDrawsWrapper.vue?vue&type=style&index=0&id=7288af8f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7288af8f",
  null
  
)

export default component.exports